import { render } from "./UseTravelPass.vue?vue&type=template&id=3fb88972&lang=pug"
import script from "./UseTravelPass.vue?vue&type=script&lang=ts"
export * from "./UseTravelPass.vue?vue&type=script&lang=ts"

import "./UseTravelPass.vue?vue&type=style&index=0&id=3fb88972&lang=scss"
script.render = render

export default script